export enum TranslationKey {
  PreOrder = 'Preorder',
  KeepMeUpdated = 'KeepMeUpdated',
  BuyNow = 'BuyNow',
  WhereToBuy = 'WhereToBuy',
  ContactSales = 'ContactSales',
  NewLabel = 'ProductStateLabelNew',
  ComingSoonLabel = 'ProductStateLabelComingSoon',
  CustomizerAddToCart = 'CustomizerAddToCart',
}
